import React, { useContext } from 'react';
import AppContext from '../context/Context';
import SurveysRoutes from '../routes/SurveysRoutes';

const SurveysLayout = () => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <SurveysRoutes />
            </div>
}

export default SurveysLayout;